import { useParams } from 'react-router-dom';
import LiveStreamViewer from '@/components/LiveSelling/LiveStreamViewer';
import { useUserContext } from '@/context/AuthContext';

export default function StreamViewPage() {
  const { id } = useParams();
  const {user} = useUserContext();
  
  return (
    <LiveStreamViewer 
      streamId={id!} 
      userId={user.id} 
      userName={user.username} 
    />
  );
}